<template>
  <div class="AssetTable">
    <table class="table table-hover" v-if="sortedAssets.length > 0">
      <thead>
        <tr>
          <th scope="col" role="button" @click="setSortBy('name')">
            Coin
            <AssetTableSortIcon column="name" />
          </th>
          <!--
          <th
            v-if="apikeysExisted.length && !isMobile"
            scope="col"
            role="button"
            class="px-1"
            @click="setSortBy('exchId')"
          >
            {{ $t("exchange.exchange") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="exchId"
            />
          </th>
          -->
          <th
            v-if="!isMobile || isLandscape || incognitoMode"
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('price')"
          >
            {{ $t("global.price") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="price"
            />
          </th>
          <th
            v-if="(!isMobile || isLandscape) && !incognitoMode"
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('holdings')"
          >
            {{ $t("global.holdings") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="holdings"
            />
          </th>
          <th
            v-if="!incognitoMode"
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('value')"
          >
            {{ $t("global.valuation") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="value"
            />
          </th>
          <th
            v-if="!isMobile"
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('percChangeHour')"
          >
            {{ $t("global.hour") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="percChangeHour"
            />
          </th>
          <th
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('percChangeDay')"
          >
            {{ $t("global.day") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="percChangeDay"
            />
          </th>
          <th
            v-if="!isMobile || isLandscape"
            scope="col"
            class="text-center"
            role="button"
            @click="setSortBy('percChangeWeek')"
          >
            {{ $t("global.week") }}
            <AssetTableSortIcon
              v-if="!isMobile || isLandscape"
              column="percChangeWeek"
            />
          </th>
          <th v-if="isMobile" scope="col" class="text-center px-0"></th>
          <th scope="col" class="text-center px-0">
            {{ !isMobile ? $t("global.notes") : "" }}
          </th>
          <th scope="col" class="text-center px-2">
            {{
              !isMobile || isLandscape
                ? $t("global.actions")
                : $t("global.edit")
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="asset in sortedAssets">
          <tr class="AssetTable__Row" :key="asset.uniqueId">
            <td
              :class="[
                'AssetTable__Name',
                asset.isDeleted ? 'AssetTable__Name_deleted' : '',
              ]"
              :title="
                asset.name +
                ' ' +
                asset.currency +
                (asset.isDeleted ? ' (Deleted coin)' : '')
              "
            >
              <AssetIcon :asset="asset" :size="24" class="AssetTable__Icon" />
              <!--
              <ExchangeIcon
                v-if="isMobile && asset.exchId > 0"
                :exchId="asset.exchId"
                :size="16"
                class="AssetTable__ExchIcon"
              />
              -->
              <span v-if="!isMobile">
                {{ asset.name }}
              </span>
              <span class="AssetTable__Symbol">{{ asset.currency }}</span>
              <a
                :href="moreInfoUrl(asset)"
                class="
                  bg-info
                  text-white
                  rounded-circle
                  AssetTable__MoreInfoLink
                "
                target="_blank"
                ><i class="fa fa-fw fa-info"></i
              ></a>
            </td>
            <!--
            <td
              v-if="apikeysExisted.length && !isMobile"
              class="text-center px-1"
            >
              <ExchangeIcon :exchId="asset.exchId" :size="isMobile ? 20 : 24" />
            </td>
            -->
            <td
              v-if="!isMobile || isLandscape || incognitoMode"
              class="hidden-mobile visible-landscape text-center"
              :class="{ bigStrWrapper: formatMoney(asset.price).length > 12 }"
            >
              <span
                :style="`--bigStrLen: ${formatMoney(asset.price).length}ch;`"
              >
                {{ formatMoney(asset.price) || "-" }}
              </span>
            </td>
            <td
              v-if="(!isMobile || isLandscape) && !incognitoMode"
              class="hidden-mobile visible-landscape text-center"
              :class="{
                bigStrWrapper: formatNumber(asset.holdings).length > 12,
              }"
            >
              <span
                :style="`--bigStrLen: ${
                  formatNumber(asset.holdings).length
                }ch;`"
              >
                {{ formatNumber(asset.holdings) || "-" }}
              </span>
            </td>
            <td
              v-if="!incognitoMode"
              class="text-center"
              :class="{
                bigStrWrapper:
                  formatMoney(asset.holdings * asset.price).length > 12,
              }"
            >
              <span
                :style="`--bigStrLen: ${
                  formatMoney(asset.holdings * asset.price).length
                }ch;`"
              >
                {{ formatMoney(asset.holdings * asset.price) || "-" }}
              </span>
            </td>
            <td
              v-if="!isMobile"
              :class="[
                'text-center',
                'AssetTable__Amount',
                asset.percChangeHour < 0 ? 'AssetTable__Amount--Negative' : '',
              ]"
            >
              {{ parseFloat(asset.percChangeHour).toFixed(2) + "%" }}
            </td>
            <td
              :class="[
                'text-center',
                'AssetTable__Amount',
                asset.percChangeDay < 0 ? 'AssetTable__Amount--Negative' : '',
              ]"
            >
              {{ parseFloat(asset.percChangeDay).toFixed(2) + "%" }}
            </td>
            <td
              v-if="!isMobile || isLandscape"
              :class="[
                'visible-landscape',
                'text-center',
                'AssetTable__Amount',
                asset.percChangeWeek < 0 ? 'AssetTable__Amount--Negative' : '',
              ]"
            >
              {{ parseFloat(asset.percChangeWeek).toFixed(2) + "%" }}
            </td>
            <td v-if="isMobile" class="text-center px-0 AssetTable__Actions">
              <button
                type="button"
                class="btn btn-link btn-lg mr-1 py-0 px-1 opacity-75"
                @click.prevent="toggleShowExpandInfo(asset)"
              >
                <span
                  class="fa"
                  :class="[
                    showExpandInfo[asset.uniqueId]
                      ? 'fa-compress'
                      : 'fa-expand',
                  ]"
                ></span>
              </button>
            </td>
            <td class="text-center px-0 AssetTable__Actions">
              <AssetTableNotes
                :asset="asset"
                :isLandscape="isLandscape"
                :updateAsset="updateAsset"
              />
            </td>
            <td class="text-center AssetTable__Actions">
              <!--
              <AssetTableTrade
                v-if="asset.exchId"
                :asset="asset"
                :isMobile="isMobile"
              />
              -->
              <AssetTableEdit :asset="asset" :isMobile="isMobile" />
            </td>
          </tr>
          <tr
            v-if="isMobile && showExpandInfo[asset.uniqueId]"
            :key="`expandInfo_${asset.uniqueId}`"
          >
            <td colspan="99" class="p-0" :class="{ 'bg-light': !nightMode }">
              <div class="AssetTable__SubTableWrapper">
                <table>
                  <tbody>
                    <tr>
                      <td>Coin</td>
                      <td>{{ asset.name || asset.currency }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("global.price") }}</td>
                      <td>{{ formatMoney(asset.price) || "-" }}</td>
                    </tr>
                    <tr v-if="!incognitoMode">
                      <td>{{ $t("global.holdings") }}</td>
                      <td>{{ formatNumber(asset.holdings) || "-" }}</td>
                    </tr>
                    <tr v-if="!incognitoMode">
                      <td>{{ $t("global.valuation") }}</td>
                      <td>
                        {{ formatMoney(asset.holdings * asset.price) || "-" }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("global.hour") }}</td>
                      <td
                        class="AssetTable__Amount"
                        :class="{
                          'AssetTable__Amount--Negative':
                            asset.percChangeHour < 0,
                        }"
                      >
                        {{ parseFloat(asset.percChangeHour).toFixed(2) + "%" }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("global.day") }}</td>
                      <td
                        class="AssetTable__Amount"
                        :class="{
                          'AssetTable__Amount--Negative':
                            asset.percChangeDay < 0,
                        }"
                      >
                        {{ parseFloat(asset.percChangeDay).toFixed(2) + "%" }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("global.week") }}</td>
                      <td
                        class="AssetTable__Amount"
                        :class="{
                          'AssetTable__Amount--Negative':
                            asset.percChangeWeek < 0,
                        }"
                      >
                        {{ parseFloat(asset.percChangeWeek).toFixed(2) + "%" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-else>
      <div class="ContentContainer clearfix text-center">
        <AddAssetButton
          class="btn-lg px-3"
          :big="true"
          :text="$t('global.add_first')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileMixin from "@/mixins/mobile";
import NumbersMixin from "@/mixins/numbers";
import { sortByTextCol, sortByNumCol } from "@/services/arrays";
import AssetIcon from "./AssetIcon.vue";
import AssetTableEdit from "./AssetTableEdit.vue";
import AssetTableNotes from "./AssetTableNotes.vue";
// import AssetTableTrade from "./AssetTableTrade.vue";
// import ExchangeIcon from "./ExchangeIcon.vue";
import AddAssetButton from "./AddAssetButton.vue";
import AssetTableSortIcon from "./AssetTableSortIcon.vue";

const sortAssets = (sortByObj) => {
  return sortByObj.sortType === "text"
    ? sortByTextCol(sortByObj.name)
    : sortByNumCol(sortByObj.name);
};

export default {
  name: "AssetTable",
  mixins: [MobileMixin, NumbersMixin],
  components: {
    AssetIcon,
    AssetTableEdit,
    AssetTableNotes,
    // AssetTableTrade,
    // ExchangeIcon,
    AddAssetButton,
    AssetTableSortIcon,
  },
  data() {
    return {
      editDropdownId: null,
      showExpandInfo: {},
    };
  },
  methods: {
    onTrClick(asset) {
      this.$router.push(`/edit/${asset.id || asset.currency}`);
    },
    moreInfoUrl(asset) {
      return `https://coinmarketcap.com/currencies/${asset.id}/`;
    },
    setSortBy(column) {
      if (this.sortBy === column) {
        this.toggleSetting("sortByDir");
      } else {
        this.setSetting({ setting: "sortBy", value: column });
        this.setSetting({ setting: "sortByDir", value: true });
      }
    },
    toggleShowExpandInfo(asset) {
      this.showExpandInfo = {
        ...this.showExpandInfo,
        [asset.uniqueId]: !this.showExpandInfo[asset.uniqueId],
      };
    },
    ...mapActions({
      setSetting: "settings/setSetting",
      toggleSetting: "settings/toggleSetting",
      updateAsset: "portfolio/updateAsset",
    }),
  },
  computed: {
    sortedAssets() {
      const { sortByObj, sortByDirTxt } = this;
      let combined = this.portfolio;

      // if (this.assetsTableExchId > -1) {
      //   combined = combined.filter((v) => v.exchId === this.assetsTableExchId);
      // }
      combined.sort(sortAssets(sortByObj));

      if (sortByDirTxt === "desc") {
        return combined.reverse();
      }
      return combined;
    },
    ...mapGetters({
      nightMode: "settings/nightMode",
      incognitoMode: "settings/incognitoMode",
      portfolio: "portfolio/portfolio",
      // apikeysExisted: "exchange/apikeysExisted",
      // assetsTableExchId: "settings/assetsTableExchId",
      sortBy: "settings/sortBy",
      sortByObj: "settings/sortByObj",
      sortByDirTxt: "settings/sortByDirTxt",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/mixins";
@import "~@/scss/variables";

.AssetTable {
  font-weight: 300;
  position: relative;
  font-size: 18px;
  color: rgba($color-secondary, 0.8);

  tbody {
    box-shadow: 0 3px 10px 0 #030630;
    border-radius: 15px;
  }

  th {
    border: none;
    color: #fff;
    font-weight: 700;
    font-size: 15px;
    white-space: nowrap;

    .fa {
      font-size: 0.85em;
      margin-left: 0.35rem;
    }
  }

  @include breakpoint-manual(max-width, $break-small) {
    font-size: 16px;
  }
}

.AssetTable__Row {
  background: #fff !important;

  td {
    padding: 25px 10px;

    // background: #fff;
    overflow: hidden;

    &:first-child {
      padding-left: 14px;
    }

    &:last-child {
      padding-right: 14px;
    }

    @include breakpoint-manual(max-width, $break-small) {
      vertical-align: middle;
      padding: 15px 2px;
      &:first-child {
        padding-left: 12px;
        padding-right: 4px;
        overflow: visible;
      }
      &:last-child {
        padding-right: 2px;
      }
    }
  }

  &:first-child {
    td {
      border-top: none;

      &:first-child {
        border-radius: 15px 0 0 0;
      }

      &:last-child {
        border-radius: 0 15px 0 0;
      }
    }
  }

  &:last-child td {
    &:first-child {
      border-radius: 0 0 0 15px;
    }

    &:last-child {
      border-radius: 0 0 15px;
    }
  }
}

.AssetTable__Name {
  position: relative;
  font-weight: 700;
  white-space: nowrap;
  max-width: 210px;
  text-overflow: ellipsis;
}

td.AssetTable__Name_deleted {
  background-color: rgba(251, 139, 187, 0.3) !important;
}

.AssetTable__Icon {
  vertical-align: inherit;
  margin-left: 3px;
  margin-right: 14px;
  line-height: 1;
  @include breakpoint-manual(max-width, $break-small) {
    margin-left: 0;
    margin-right: 13px;
  }
}

.AssetTable__ExchIcon {
  position: absolute;
  bottom: 8px;
  left: 27px;
  padding: 2px;
  border-radius: 50%;
  background-color: #fff;
  font-size: 0;
}

.AssetTable__Symbol {
  font-weight: 300;
  margin-left: 5px;
  opacity: 0.5;

  @include breakpoint-manual(max-width, $break-small) {
    margin: 0;
    opacity: 0.8;
  }
}

.table-hover tbody tr:hover td {
  background: #f4f4f4;
  transition: background 0.1s linear;
}

.AssetTable__Amount {
  color: $color-tertiary;

  &--Negative {
    color: $color-primary;
  }
}

.AssetTable__MoreInfoLink {
  display: inline-block;
  padding: 0;
  text-align: center;

  width: 15px;
  height: 15px;

  position: absolute;
  left: 38px;
  top: 14px;

  font-size: 0.7rem;
  opacity: 0.9;

  @include breakpoint-manual(max-width, $break-small) {
    left: 30px;
    top: 11px;
  }
}

.AssetTable__Actions {
  overflow: visible !important;
}

.AssetTable__SubTableWrapper {
  font-size: 90%;
  table {
    width: 100%;
  }
  tbody {
    box-shadow: none;
    border-radius: 0;
  }
  td {
    padding: 0.5em 1em;
    &:last-child {
      font-weight: 400;
    }
  }
}

.bigStrWrapper {
  padding: 0 !important;
  > span {
    display: block;
    margin: 25px 10px;
    width: 11ch;
    max-width: 11ch;
    white-space: nowrap;
    overflow: hidden;
    animation: 2s cubic-bezier(0.65, 0.05, 0.36, 1) 0s infinite alternate
      bigStrAnimation;
    @include breakpoint-manual(max-width, $break-small) {
      margin: 15px auto;
    }
  }
}
@keyframes bigStrAnimation {
  from {
    text-indent: 0.5ch;
  }
  to {
    text-indent: calc(11ch - var(--bigStrLen));
  }
}
</style>
